import React from "react";
import { Grid } from "semantic-ui-react";
import {
  Heading2,
  Body2,
} from "../../../components/value-cssmodules/TextComponent";
import { FormattedMessage } from "react-intl";
import styles from "./HowIsItWork.module.scss";
import LightButton from "../../../components/Button/LightButton";
import Steps from "../../../components/Steps";

const HowIsItWork = () => {
  const steps = [
    {
      stepId: "home.designers.steps.register",
      subId: "home.designers.steps.register.sub",
    },
    {
      stepId: "home.designers.steps.createProfile",
      subId: "home.designers.steps.createProfile.sub",
    },
    {
      stepId: "home.designers.steps.addPatterns",
      subId: "home.designers.steps.addPatterns.sub",
    },
    {
      stepId: "home.designers.steps.setPrice",
      subId: "home.designers.steps.setPrice.sub",
    },
    {
      stepId: "home.designers.steps.startEarning",
      subId: "home.designers.steps.startEarning.sub",
    },
  ];
  const elements = ["one", "two", "three", "four"];
  return (
    <section className={styles.howWork}>
      <Grid padded>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Heading2>
              <FormattedMessage
                id={"nav.headingHowIsDHP"}
                defaultMessage={"How it is working?"}
              />
            </Heading2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column width={12}>
            <Body2 className={styles.start}>
              <FormattedMessage
                id={"nav.bodyHowIsDHP"}
                defaultMessage={"start the adventure in 5 easy steps"}
              />
            </Body2>
          </Grid.Column>
        </Grid.Row>
        <ol className={styles.punctation}>
          <div className={styles.arrows}>
            {elements.map((ele: any, i: number) => (
              <img key={`${ele}-${i}`} src="/icons/next-1.svg" alt="" />
            ))}
          </div>
          {steps.map((steps: any, i: number) => (
            <Steps key={`${steps.stepId}-${i}`} steps={steps} />
          ))}
        </ol>
        <Grid.Row columns={1}>
          <Grid.Column textAlign="center">
            <LightButton>
              <FormattedMessage
                id={"nav.invitationabutton"}
                defaultMessage={"See all patterns"}
              />
            </LightButton>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </section>
  );
};

export default HowIsItWork;
